import PropTypes from 'prop-types';
import React from 'react';
import { Carousel } from 'components/Carousel/Carousel';
import { isEmpty } from 'helpers/verify';
import media from 'decorators/Media/Media';

export const BenefitsUnwrapped = ({ mediaQueryMd, backgroundColor, title, benefits }) => {
  let content;

  if (isEmpty(benefits)) {
    return null;
  }

  if (mediaQueryMd) {
    content = (
      <ul>
        {benefits.map(benefit => (
          <li key={benefit.title} className="pricing-benefits__item">
            <h3>{benefit.title}</h3>
            <p>{benefit.description}</p>
          </li>
        ))}
      </ul>
    );
  } else {
    content = (
      <Carousel
        className="carousel--benefits"
        cellAlign="left"
        edgeEasing="easeCubicOut"
        speed={150}
        slidesToShow={1}
        slidesToScroll={1}
        showMobileControls>
        <span>
          {benefits.slice(0, 3).map(benefit => (
            <div key={benefit.title} className="pricing-benefits__item">
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </div>
          ))}
        </span>
        <span>
          {benefits.slice(3, 6).map(benefit => (
            <div key={benefit.title} className="pricing-benefits__item">
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </div>
          ))}
        </span>
      </Carousel>
    );
  }

  return (
    <div className={`bg--${backgroundColor || 'white'}`}>
      <div className="pricing-benefits">
        <h2 className="gamma">{title}</h2>
        {content}
      </div>
    </div>
  );
};

BenefitsUnwrapped.propTypes = {
  mediaQueryMd: PropTypes.bool,
  backgroundColor: PropTypes.oneOf(['white', 'light']),
  benefits: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      type: PropTypes.string,
    })
  ),
  title: PropTypes.string,
};

BenefitsUnwrapped.propMapper = (state, moduleDef) => {
  if (!moduleDef.information) {
    // eslint-disable-next-line no-console
    console.error(`Benefits information missing for ${moduleDef.moduleName}: ${JSON.stringify(moduleDef)}`);
  }

  return {
    title: moduleDef.title,
    benefits: moduleDef.information || [],
  };
};

export const Benefits = media(BenefitsUnwrapped);
